import {
  Column,
  Stack,
  Text,
  Heading,
  Columns,
  Box,
} from 'braid-design-system';
import { DateTime } from 'luxon';
import React from 'react';

import type { ClientListingForListingsTab } from 'src/types/graphql-derived';

import { TitleStatus } from './TitleStatus';

interface TitleProps {
  listing: ClientListingForListingsTab;
}

const Title = ({ listing }: TitleProps) => (
  <Column>
    <Columns space="small" collapseBelow="tablet">
      <Column>
        <Stack space="xsmall">
          <Heading level="4" weight="weak">
            {listing.title}
          </Heading>
          <Text size="small" tone="secondary">
            Created: {formatDate(listing.createdDate)}
          </Text>
        </Stack>
      </Column>
      <Column width="content">
        <Box data={{ testid: 'listings-tab-table-row-title-status' }}>
          <TitleStatus listing={listing} />
        </Box>
      </Column>
    </Columns>
  </Column>
);

export default Title;

const formatDate = (date: string) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
